// extracted by mini-css-extract-plugin
export default {"container":"Gift_container__vnfFp","giftCard":"Gift_giftCard__sYPZY","giftImage":"Gift_giftImage__4xgmG"};